import { supabaseClient } from "@/lib/supabase";
import { queryOptions, useQuery } from "@tanstack/react-query";

export async function selectInjectionByInjectingClinicianId(injectingClinicianId: string) {
    const { data, error } = await supabaseClient
        .from("injections_view")
        .select("*, events(*, shared_attributes(*))")
        .eq("injecting_clinician_id", injectingClinicianId);
    if (error) throw error;
    return data;
}

export const injectionQueryKey = (injectionId: string) => ["injection", { injection_id: injectionId }];

export const selectInjectionByInjectingClinicianIdQueryOptions = (injectingClinicianId: string) => {
    return queryOptions({
        queryKey: injectionQueryKey(injectingClinicianId),
        queryFn: () => selectInjectionByInjectingClinicianId(injectingClinicianId),
    });
};

export const useSelectInjectionByInjectingClinicianId = (injectingClinicianId: string) => {
    const options = selectInjectionByInjectingClinicianIdQueryOptions(injectingClinicianId);
    const query = useQuery(options);
    return query;
};
